import { render } from "./GamerCard.vue?vue&type=template&id=1993dfa2"
import script from "./GamerCard.vue?vue&type=script&lang=js"
export * from "./GamerCard.vue?vue&type=script&lang=js"

import "./GamerCard.vue?vue&type=style&index=0&id=1993dfa2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__